import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  /* max-width: 992px; */
  margin: 0 auto;
  padding: 2.5rem 1.5rem;

  display: flex;
  flex-direction: row;
`;
